import { MovieDto } from '@interfaces/movieInterface';
import { movieService } from '@services/index';
import { useMutation } from '@tanstack/react-query';

export default function useMutationEditMovie() {
	return useMutation({
		mutationFn: (movieDto: MovieDto) => movieService.editMovie(movieDto)
	});
}
